exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  font-family: \"Raleway\", \"HelveticaNeue\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  line-height: 1.6;\n}\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.main {\n  padding-left: 20px;\n}\na.post-link {\n  color: #2783BF;\n  text-decoration: none;\n  font-size: 1.3em;\n}\na.post-link:hover {\n  border-bottom: 1px dashed #0FA0CE;\n}\nul.posts li {\n  padding: 3px;\n}\n.pagination {\n  margin-top: 16px;\n}\n.pagination a {\n  text-decoration: none;\n  padding: 2px 4px;\n  color: #2783BF;\n  font-size: 1.2em;\n}\n.pagination a.current {\n  color: #fff;\n  background-color: #2783BF;\n}\n.author {\n  padding: 2px 4px;\n  border: 1px solid #E1E1E1;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #666;\n  background-color: #F1F1F1;\n  margin-left: 20px;\n}\n.time {\n  margin-left: 20px;\n  font-size: .8em;\n  color: #9c9c9c;\n}\n.tag {\n  font-size: 0.8em;\n  color: #fff;\n  background-color: #2783BF;\n  padding: 3px 5px;\n  margin-left: 20px;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!./static/css/style.css
 ** module id = 4
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!./static/css/style.css
 ** module id = 4
 ** module chunks = 1
 **/